/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'basic/volume-1214280': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M16.93 4.1a1 1 0 00-1 .12L11.15 8H7.5a1 1 0 00-1 1v6a1 1 0 001 1h3.65l4.73 3.78a1 1 0 00.62.22.91.91 0 00.43-.1 1 1 0 00.57-.9V5a1 1 0 00-.57-.9zM15.5 16.92l-3.38-2.7a1 1 0 00-.62-.22h-3v-4h3a1 1 0 00.62-.22l3.38-2.7z"/>'
  }
})
